import {
  useDispatch, useSelector,
} from 'react-redux';

import {
  getLineOfBusinessContent,
  getSelectedLineOfBusiness,
  LinesOfBusinessContent,
} from '@/core/store/reducers/staticContent';

import { selectUser } from '@/features/Config/store/selectors';
import { updateLobId } from '@/features/Config/store/actions';
import { getStoredLobId } from '@/utils/localStorage';

const useAuthWrapperHook = () => {
  const dispatch = useDispatch();

  const user = useSelector(selectUser);

  const fetchLobData = () => {
    if (!user?.data?.email) return;

    dispatch(getLineOfBusinessContent(
      user?.data?.email
    ) as Awaited<any>)
      .then(({ data }: Omit<LinesOfBusinessContent, 'message'>) => {
        const storedLobId = getStoredLobId();
        const defaultSelectedLob = data
          ?.find(lineOfbusiness => lineOfbusiness.lobId === storedLobId) || data?.[0];

        dispatch(getSelectedLineOfBusiness(defaultSelectedLob));
        dispatch(updateLobId(defaultSelectedLob?.lobId));
      })
      .catch((err: unknown) => {
        // Handle error silently or with proper error handling
        if (process.env.NODE_ENV === 'development') {
          // eslint-disable-next-line no-console
          console.error('Failed to fetch line of business data:', err);
        }
      });
  };

  return { fetchLobData };
};

export default useAuthWrapperHook;
